import { Type } from '@sinclair/typebox';
import { parts } from "../atlas.mjs";
export const knownCustomStickerAttributes = Type.Object({ quantity: Type.Optional(Type.Number()) });
export const productItemSchema = Type.Object({
    attributes: Type.Intersect([knownCustomStickerAttributes, Type.Record(Type.String(), Type.Unknown())]),
    productFamilyName: Type.String(),
    productName: Type.String(),
    sku: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    settings: Type.Optional(Type.Record(Type.String(), Type.Unknown())),
    svgSettings: Type.Optional(Type.Record(Type.String(), Type.Unknown())),
    ui: Type.Optional(Type.Array(Type.Unknown())),
});
export const customStickerSchema = Type.Object({
    /**
     * Url to a preview image of the custom sticker.
     */
    imageUrl: Type.Optional(Type.String()),
    cartId: Type.Optional(Type.String()),
    attributes: Type.Intersect([knownCustomStickerAttributes, Type.Record(Type.String(), Type.Unknown())]),
    parts: parts,
    productItem: productItemSchema,
    price: Type.Optional(Type.Array(Type.Unknown())),
});
export const customStickerWithIdSchema = Type.Intersect([
    customStickerSchema,
    Type.Object({
        id: Type.String(),
        version: Type.String(),
    }),
]);
export const saveCustomStickerRequestSchema = Type.Object({
    customSticker: Type.Omit(customStickerSchema, ['cartId']),
});
export const customStickerResponseSchema = Type.Object({
    customSticker: customStickerWithIdSchema,
});
//# sourceMappingURL=index.js.map